import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TaskEffect, TaskSelector } from '../../shared/model';
import { TaskStoreService } from '../task-store.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'ubs-task-effect',
  templateUrl: './task-effect.component.html',
  styleUrls: ['./task-effect.component.scss']
})
export class TaskEffectComponent implements OnInit, OnChanges{
  @Input() effect:TaskEffect;
  title:string;

  readonly context$ = this.taskStoreService.context$

  private destroy$ = new Subject<void>()

  context:any;

  constructor(private taskStoreService:TaskStoreService){}
  
  ngOnInit(): void {
    this.context$.pipe(takeUntil(this.destroy$)).subscribe(context => {
      this.context = context;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["effect"]){
      console.log(this.effect)
      this.title = this.effect.title;
    }
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
}
